import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select";
import InputNumber from "../components/InputNumber";
import Output from "../components/Output";

import { timberShear } from "../../utils/services/calculators";
import { Text, useToast } from "@chakra-ui/react";

function TimberShear({}) {
  const toast = useToast();
  // BENDING
  const [shearInputs, setShearInputs] = useState({
    forest_type: "Nativa",
    timber: "Coníferas",
    timber_class: "D20",
    timber_type: "Madeira serrada",
    load_class: "Permanente",
    moisture_class: "1 (≤ 65%)",
    b: "",
    h: "",
    vsd: "",
  });
  const [shearOutputs, setShearOutputs] = useState({
    fv0_d: "",
    tens_tang_d: "",
    memorial: {},
  });

  function updateShearInputs(name, value) {
    if (
      name === "forest_type" ||
      name === "timber" ||
      name === "timber_class" ||
      name === "timber_type" ||
      name === "load_class" ||
      name === "moisture_class"
    ) {
      if (value === "Nativa") {
        setShearInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D20",
        }));
      } else if (value === "Plantada") {
        setShearInputs((prevInputs) => ({
          ...prevInputs,
          ["timber"]: "Coníferas",
        }));
        setShearInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      }
      if (value === "Coníferas") {
        setShearInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      } else if (value === "Folhosas") {
        setShearInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D18",
        }));
      }
      setShearInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (value === "") {
      setShearInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setShearInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setShearOutputs({
      fv0_d: "",
      tens_tang_d: "",
    });
  }

  function onShearCalculate() {
    if (
      shearInputs["b"] === "" ||
      shearInputs["h"] === "" ||
      shearInputs["vsd"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      shearInputs["b"] === 0 ||
      shearInputs["h"] === 0 ||
      shearInputs["vsd"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      timberShear(shearInputs).then((response) => {
        setShearOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "timber-shear-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "timber-shear-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Cisalhamento:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Floresta"
              elements={["Nativa", "Plantada"]}
              unit=""
              onChange={(e) => updateShearInputs("forest_type", e.target.value)}
              value={shearInputs["forest_type"]}
            />
            {shearInputs["forest_type"] === "Plantada" && (
              <Select
                text="Madeira"
                elements={["Coníferas", "Folhosas"]}
                unit=""
                onChange={(e) => updateShearInputs("timber", e.target.value)}
                value={shearInputs["timber"]}
              />
            )}
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Classe"
              elements={
                shearInputs["forest_type"] === "Nativa"
                  ? ["D20", "D30", "D40", "D50", "D60"]
                  : shearInputs["forest_type"] === "Plantada" &&
                      shearInputs["timber"] === "Coníferas"
                    ? [
                        "C14",
                        "C16",
                        "C18",
                        "C20",
                        "C22",
                        "C24",
                        "C27",
                        "C30",
                        "C35",
                        "C40",
                        "C45",
                        "C50",
                      ]
                    : shearInputs["forest_type"] === "Plantada" &&
                        shearInputs["timber"] === "Folhosas"
                      ? ["D18", "D24", "D30", "D35", "D40", "D50", "D60", "D70"]
                      : []
              }
              unit=""
              onChange={(e) =>
                updateShearInputs("timber_class", e.target.value)
              }
              value={shearInputs["timber_class"]}
            />
            <Select
              text="Classe de umid."
              elements={["1 (≤ 65%)", "2 (≤ 75%)", "3 (≤ 85%)", "4 (> 85%)"]}
              unit=""
              onChange={(e) =>
                updateShearInputs("moisture_class", e.target.value)
              }
              value={shearInputs["moisture_class"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Tipo"
              elements={[
                "Madeira serrada",
                "Madeira roliça",
                "Madeira lamelada colada (MLC)",
                "Madeira lamelada colada cruzada (MLCC)",
                "Madeira laminada colada (LVL)",
                "Madeira recomposta",
              ]}
              unit=""
              onChange={(e) => updateShearInputs("timber_type", e.target.value)}
              value={shearInputs["timber_type"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Classe de carregamento"
              elements={[
                "Permanente",
                "Longa duração",
                "Média duração",
                "Curta duração",
                "Instantânea",
              ]}
              unit=""
              onChange={(e) => updateShearInputs("load_class", e.target.value)}
              value={shearInputs["load_class"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateShearInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateShearInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Vsd"
              unit="tf"
              onChange={(e) => updateShearInputs("vsd", e.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button className={styles.calculateButton} onClick={onShearCalculate}>
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <Output text="fv0,d" value={shearOutputs["fv0_d"]} unit="MPa" />
          <Output text="τd" value={shearOutputs["tens_tang_d"]} unit="MPa" />
          {shearOutputs["tens_tang_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {shearOutputs["tens_tang_d"].toFixed(2) +
                " ≤ " +
                shearOutputs["fv0_d"].toFixed(2) +
                " → "}
              {shearOutputs["tens_tang_d"] <= shearOutputs["fv0_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {shearOutputs["memorial"] &&
          Object.entries(shearOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default TimberShear;
